import { panelOrderKeys } from '../api/panelOrder.api';
import { useQuery, UseQueryOptions } from 'react-query';
import client from '@/utils/httpClient';

export interface LabMatchResultPanel {
	id: string;
	panelName: string;
	accessionNumber: string;
	reportingLab: string;
	diagnosis: string;
	pdfUrl: string;
	reportDate?: Date;
}

export interface LabMatchResultPatient {
	firstName: string;
	lastName: string;
	dateOfBirth: Date;
	age: number;
	ethnicity?: string;
	race?: string;
	externalId: string;
}

export interface LabMatchResult {
	patient: LabMatchResultPatient;
	panelOrders: LabMatchResultPanel[];
}

export const labMatchKeys = {
  patientSearch: (orgId: string, firstName: string, lastName: string, dateOfBirth: Date) => [
    ...panelOrderKeys.list(),
    'patientsearch',
    orgId,
    firstName,
    lastName,
    dateOfBirth?.toJSON()
  ]
};

export function getPanelOrdersByPatientDemographics(
  orgId: string,
  firstName: string,
  lastName: string,
  dateOfBirth: Date
) {
  return client
    .get(
      `/api/panelorders/patientsearch?orgId=${orgId}&firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth.toJSON()}`
    )
    .then((response) => response.data as LabMatchResult[]);
}

export function usePanelOrdersByPatientDemographics(
  orgId: string,
  firstName: string,
  lastName: string,
  dateOfBirth: Date,
  options?: UseQueryOptions<LabMatchResult[]>
) {
  return useQuery(
    labMatchKeys.patientSearch(orgId, firstName, lastName, dateOfBirth),
    () => getPanelOrdersByPatientDemographics(orgId, firstName, lastName, dateOfBirth),
    {
      ...options,
      enabled:
				!!orgId &&
				!!firstName &&
				!!lastName &&
				!!dateOfBirth &&
				(options?.enabled !== undefined ? options.enabled : true)
    }
  );
}
